/* eslint-disable no-prototype-builtins */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Button, TableContainer } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { Grid } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { loanApplicationStatus } from "assets/properties/properties";
import { parseAndSetFlag, textFormat } from "utils/Utils";
import { useNavigate } from "react-router-dom";
import Table from "components/UpdateUi/Table/Table";
import { PreSanctionApprovalData } from "assets/properties/properties";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import { headerLabel } from "assets/properties/properties";
import { APPLICATION_SUB_TYPE_PRE_PLEDGE } from "assets/properties/properties";
import DisbursalSendBack from "../../Disbursal/DisbursalSendBack";
const style = () => ({
  buttonContainer: { textAlign: "right" },
  nextButton: { padding: "0px 40px" },
  nextButton1: { padding: "0px 40px" },
});

const PreSanctionDecision = ({
  setNext,
  setBack,
  loanApplicationId,
  editable,
  closeModal,
  status,
  classes,
  deviation,
  collateralDescp,
  featureFlags,
  customerName,
  loanAccountNumber,
  subStatus
}) => {
  const navigate = useNavigate();
  const { authToken } = useSelector((state) => state.login.authData);
  const [tableData, setTableData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [isDeviation, setIsDeviation] = useState(deviation);
  const [isCollateralDescp, setIsCollateralDescp] = useState(collateralDescp);
  const [approvalTableData, setApprovalTableData] = useState([]);
  const [showApprovalTable, setShowApprovalTable] = useState(false);

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    setIsDeviation(deviation);
  }, [deviation]);

  useEffect(() => {
    setIsCollateralDescp(collateralDescp);
  }, [collateralDescp]);

  const mapApprovalMapToTable = (approvalMap = {}) => {
    return Object?.entries(approvalMap)?.map(([designation, users = []]) => ({
      designation,
      name: users?.map(u => u?.name)?.join(", "),
      username: users?.map(u => u?.username)?.join(", "),
    }));
  };

  const handleSubmit = async () => {
    setCallInProgress(true);

    try {
      if (!isDeviation) {
        const res = await apiHandler({
          url: endpoint.DEVIATION_VALIDATE + loanApplicationId,
          method: "POST",
          authToken,
        });

        if (res?.data?.error_code) {
          toastUpdate("Error", res?.data?.user_description, true);
          setCallInProgress(false);
          return;
        }

        setIsDeviation(res?.data?.isDeviation);
        const approvalMap = res?.data?.userBasicDetailResponse?.adminUserMap;
        if (approvalMap) {
          const tableRows = mapApprovalMapToTable(approvalMap);
          setApprovalTableData(tableRows);
          setShowApprovalTable(true);
          setCallInProgress(false);
          return;
        }
      }
      if (isDeviation && !isCollateralDescp && subStatus !== APPLICATION_SUB_TYPE_PRE_PLEDGE ) {
        const res = await apiHandler({
          url: endpoint.COLLATERAL_APPROVAL_VALIDATE + loanApplicationId,
          method: "POST",
          authToken,
        });

        if (res?.data?.error_code) {
          toastUpdate("Error", res?.data?.user_description, true);
          setCallInProgress(false);
          return;
        }

        setIsCollateralDescp(res?.data?.isCollateralDescp);

        if (!res?.data?.isCollateralDescp) {
           navigate("/loanservice/preSanction", {
          state: {
            toastType: "Information",
            toastMessage: "Loan application send for collateral approval."
          }
        });
          return;
        }
      }

      const res = await apiHandler({
        url: endpoint.SANCTION_UPDATED_CHANGE_STATUS + loanApplicationId,
        method: "PUT",
        authToken,
      });
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        setCallInProgress(false);
        return;
      }
      getApprovalHistoryData("closeModal");
    } catch (err) {
      toastUpdate(
        "Error",
        err?.user_description || "Something went wrong",
        true
      );
    } finally {
      setCallInProgress(false);
    }
  };
  const getApprovalHistoryData = async (type) => {
    const result = await apiHandler({
      url: endpoint.COLLATERAL_EVALUATION_STATUS + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });

    if (
      result?.data?.error_code ||
      !result?.data ||
      Object.keys(result?.data).length === 0
    ) {
      if (type === "closeModal") {
        navigate("/loanservice/preSanction", {
          state: {
            toastType: "Success",
            toastMessage: "Loan sanctioned successfully.",
          },
        });
      }
      return;
    }

    const result1 = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_FIND_BY_CODE,
      method: "GET",
      authToken: authToken,
    });

    const reportData = result?.data;
    const hierarchyData = result1?.data;
    let labelMap = {};

    for (let key in reportData) {
      if (reportData.hasOwnProperty(key)) {
        let levelData = reportData[key];
        let dataArray = levelData.approvalUsers || [];
        if (dataArray.length === 0) {
          labelMap[key] = {
            level: levelData?.level || key,
            name: "N/A",
            role: "N/A",
            designationCode: "N/A",
            approved: levelData?.approved ? "approved" : "pending",
          };
        } else {
          dataArray?.forEach((decisionDetails) => {
            let label = decisionDetails?.level || key;
            const hierarchyName =
              hierarchyData?.find(
                (item) => item.code === decisionDetails?.hierarchyCode
              )?.name || "Unknown";

            if (!labelMap[label]) {
              labelMap[label] = {
                level: levelData?.level || key,
                name: decisionDetails?.name,
                role: decisionDetails?.role,
                designationCode: decisionDetails?.designation,
                approved: levelData?.approved ? "approved" : "pending",
              };
            } else {
              labelMap[label].name += `, ${decisionDetails?.name}`;
              labelMap[label].role += `, ${decisionDetails?.role}`;
            }
          });
        }
      }
    }

    let tableData = Object.values(labelMap);
    setShowTable(true);
    setTableData(tableData);
  };
  const handleCloseModal = (type) => {
    let setMessage = ""; 
    if(!isDeviation){
      setMessage = "Loan Send For Deviation";
    }else if(isDeviation && !isCollateralDescp){
      setMessage = "Loan Send For Deviation";
    }else{
      setMessage = "Loan sanctioned successfully.";
    }
    navigate("/loanservice/preSanction", {
      state: {
        toastType: "Success",
        toastMessage: setMessage,
      },
    });
  };
  const isCloseMode =
  tableData.length > 0 || approvalTableData.length > 0;

  return (
    <Grid container>
      <Grid item xs={12}>
        <SubHeader label="Pre Sanction Decision" 
        subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
                         onlyLabel/>
      </Grid>
      <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
        <CustomeTextField
          label="Loan Account Number"
          required
          id="loan_account_number"
          value={loanAccountNumber || ""}
          disabled= {true}
          />
      </Grid>
      <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
        <CustomeTextField
          label="Customer Name"
          required
          id="customer_name"
          value={customerName || ""}
          disabled= {true}
          />
      </Grid>
      <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
        <textarea
          placeholder="Remarks"
          onChange={(e) => editable && setRemarks(e.target.value)}
          value={textFormat(remarks)}
          disabled={!editable}
          style={{ width: "100%", borderRadius: 5 }}
        />
      </Grid>

      <GridItem xs={12} className={classes.buttonContainer}>
        <DisbursalSendBack
          loanApplicationId={loanApplicationId}
          classes={classes}
          callInProgress={callInProgress}
          setCallInProgress={setCallInProgress}
          toastUpdate={toastUpdate}
          size="large"
          style={{ width: "auto" }}
          featureFlags={featureFlags}
          navigateTo={"/loanservice/preSanction"}
        />
        <Button className={classes.nextButton1} onClick={setBack}>
          Back
        </Button>
        <Button
          className={classes.nextButton}
          disabled={callInProgress}
          onClick={(event) => {
            isCloseMode  ? handleCloseModal() : handleSubmit();
          }}
        >
          {" "}
          {isCloseMode ? "Close" : "Submit"}
        </Button>
      </GridItem>
      {showApprovalTable && (
        <GridContainer>
          <SubHeader label="Deviation Approval Required" />
          <TableContainer>
            <Table
              columns={PreSanctionApprovalData?.approvalTableColumns}
              rows={approvalTableData}
              styles="style"
            />
          </TableContainer>
        </GridContainer>
      )}
      {showTable && (
        <GridContainer>
          <SubHeader label="Approval History" />
          <TableContainer>
            <Table columns={PreSanctionApprovalData?.approvalCollateralColumns} rows={tableData} styles="style" />
          </TableContainer>
        </GridContainer>
      )}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

PreSanctionDecision.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.any,
  editable: PropTypes.bool,
  closeModal: PropTypes.func,
  status: PropTypes.string,
  deviation: PropTypes.bool,
  collateralDescp: PropTypes.bool,
};

export default withStyles(style)(PreSanctionDecision);
